import * as Types from '../../gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFrontendCurrentUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetFrontendCurrentUserQuery = { __typename?: 'Query', getFrontendCurrentUser: { __typename?: 'GetCurrentUserFrontendObjectTpJwhAQJ', object?: { __typename?: 'GetCurrentUserFrontendObject', id: string, deprecatedMongoId?: string | null, email: string, firstName: string, lastName: string, locale: Types.Locales, fullName: string, phone?: string | null, maskedPhoneNumber?: string | null, role: Types.UserRoles, hasAnyBankPermission: boolean, emailVerified: boolean, isTwoFactorActivated: boolean, isAuthenticatedWithGoogleSSO: boolean, isMigratedOnStytch: boolean, isLoginSmsMfaActivated: boolean, isBankChangeSmsMfaActivated: boolean, createdAtUtc: GraphQL_Date, connectedAsAdministrator: boolean, zeffyAdministrator: boolean, hasSeenReferralPage: boolean, isOnboardedOnCheckinManager: boolean, hasDismissedEmailInfobox: boolean, hasDismissedReferralPromptAtFirstPayout: boolean, hasDismissedEmailTemplatePrompt: boolean, stripeCustomers?: Array<{ __typename?: 'StripeCustomerObject', id: string, country: Types.OrganizationCountry, stripeCustomerId: string }> | null, currentOrganization?: { __typename?: 'OrganizationObject', name: string, id: string, address?: string | null, city?: string | null, postalCode?: string | null, country: Types.OrganizationCountry, region?: string | null, phoneNumber?: string | null, charityNumber?: string | null, stripeCustomAccountId?: string | null, signatureUrl?: string | null, logoUrl?: string | null, dismissOnboardingOnFormPageAt?: GraphQL_Date | null, previewFirstFormAt?: GraphQL_Date | null, hasAdministrativeInformation: boolean, hasCharityNumber: boolean, canGenerateReceipt: boolean, deprecatedMongoId?: string | null, volumeThresholdReached?: number | null, bankDescriptor?: string | null, referralQuestion?: Types.ReferralQuestionChoice | null, referralQuestionOther?: string | null, cause?: Types.OrganizationCause | null, website?: string | null, stripeUserId?: string | null, hasStripeCustomFlowStarted: boolean, isStripeCustomAccountActive: boolean, stripeCustomAccountActiveAtUtc?: GraphQL_Date | null, type?: Types.OrganizationType | null, fraudulent: boolean, color?: string | null, hideFromZeffyMap: boolean, isPoBoxAddress?: boolean | null, hasAtLeastOnePayment?: boolean | null, badTipperHubspotFlag?: boolean | null, category?: Types.OrganizationCategory | null, firstPaymentDate?: GraphQL_Date | null, lastPaymentDate?: GraphQL_Date | null, fourthPaymentDate?: GraphQL_Date | null, onboardedFormCategory?: Types.FormCategory | null, propublicaCCode?: number | null, hasFinishZeffyOnboarding: boolean, createdAtUtc?: GraphQL_Date | null, balanceTransferDelayDay: number, stripeTopupSourceId?: string | null, activationChecklistExperiment?: string | null, engagementChecklistExperiment?: Types.AmplitudeVariantValue | null, referralAmountLimit: number, hasDismissActivationPayoutSuccessCard?: boolean | null, engagementCheckListStepChecked?: Array<string> | null, hasVisitorReports?: boolean | null, demotivateEmbeds?: Types.AmplitudeVariantValue | null, hasImportGmailContacts?: boolean | null, hasImportMailchimpContacts?: boolean | null, hubspotNpoStarterDealId?: string | null, npoStarterStateCertificateUrl?: string | null, npoStarterToDoListStepChecked?: Array<string> | null, stripeVerificationSucceededBannerShown?: boolean | null, featureTreasuryEnabled: boolean, featureIssuingEnabled: boolean, hasClosedFinancialAccountReadyBanner: boolean } | null, currentOrganizationDetails?: { __typename?: 'OrganizationDetailsObject', closingDate?: GraphQL_Date | null, fundsRaised: number, numberContacts: number, numberPayments: number, numberForms: number, numberUserAccounts: number, numberOfReferrals: number } | null, organizationGroups: Array<{ __typename?: 'OrganizationGroupObject', organizationId: string, role: Types.UserRoles, permissions: Array<Types.UserPermissions>, organization: { __typename?: 'OrganizationObject', name: string, id: string } }> } | null } };

export type IsUserEmailRegisteredMutationVariables = Types.Exact<{
  isEmailRegisteredInput: Types.IsEmailRegisteredInput;
}>;


export type IsUserEmailRegisteredMutation = { __typename?: 'Mutation', isUserEmailRegistered: { __typename?: 'IsUserEmailRegisteredResponseObject', object?: { __typename?: 'IsUserEmailRegisteredObject', userId?: string | null, userRegistrationStatus: Types.UserRegistrationStatus, hasPassword: boolean, hasResetPasswordToken: boolean, hadPasswordInSimplykV1: boolean, fundraiserCreationToken?: string | null, shouldAuthenticateWithGoogle?: boolean | null } | null, error?: { __typename?: 'IsUserEmailRegisteredResponseObjectErrorObject', code?: string | null, message: string } | null } };

export type SignInMutationVariables = Types.Exact<{
  signInInput: Types.SignInFrontendInput;
}>;


export type SignInMutation = { __typename?: 'Mutation', signIn: { __typename?: 'AccessTokenObjectcJkWPZxQ', object?: { __typename?: 'AccessTokenObject', email?: string | null, shouldAuthenticateWithTwoFactor?: boolean | null, shouldAuthenticateBySms?: boolean | null, stytchVerdict?: string | null, maskedPhoneNumber?: string | null, role?: Types.UserRoles | null, locale?: Types.Locales | null, redirectUrl?: string | null, shouldRedirectToMFAConfig?: boolean | null } | null, error?: { __typename?: 'AccessTokenObjectcJkWPZxQErrorObject', code?: string | null } | null } };

export type ResendTwoFactorCodeMutationVariables = Types.Exact<{
  signInInput: Types.SignInFrontendInput;
}>;


export type ResendTwoFactorCodeMutation = { __typename?: 'Mutation', resendTwoFactorCode: { __typename?: 'Boolean6FkdZdCF', object?: boolean | null } };

export type SendTwoFactorCodeMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SendTwoFactorCodeMutation = { __typename?: 'Mutation', sendTwoFactorCode: { __typename?: 'BooleanxHOYO2y6', object?: boolean | null } };

export type VerifyTwoFactorCodeMutationVariables = Types.Exact<{
  value: Types.Scalars['String'];
}>;


export type VerifyTwoFactorCodeMutation = { __typename?: 'Mutation', verifyTwoFactorCode: { __typename?: 'BooleanmKDGMT6s', object?: boolean | null, error?: { __typename?: 'BooleanmKDGMT6sErrorObject', code?: string | null, message: string } | null } };

export type SignInAsAdministratorMutationVariables = Types.Exact<{
  signInAsAdministratorInput: Types.SignInAsAdministratorInput;
}>;


export type SignInAsAdministratorMutation = { __typename?: 'Mutation', signInAsAdministrator: { __typename?: 'AccessTokenObjectoiSUG77E', object?: { __typename?: 'AccessTokenObject', role?: Types.UserRoles | null, locale?: Types.Locales | null } | null, error?: { __typename?: 'AccessTokenObjectoiSUG77EErrorObject', code?: Types.AccessTokenError | null } | null } };

export type SwitchOrgAsAdministratorMutationVariables = Types.Exact<{
  switchOrgAsAdministratorInput: Types.SwitchOrgAsAdministratorInput;
}>;


export type SwitchOrgAsAdministratorMutation = { __typename?: 'Mutation', switchOrgAsAdministrator: { __typename?: 'AccessTokenResponseObject', object?: { __typename?: 'AccessTokenObject', role?: Types.UserRoles | null, locale?: Types.Locales | null } | null, error?: { __typename?: 'AccessTokenResponseObjectErrorObject', code?: Types.AccessTokenError | null } | null } };

export type SignUpMutationVariables = Types.Exact<{
  signUpInput: Types.SignUpInput;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp: { __typename?: 'AccessTokenObjecthe6oFwHO', object?: { __typename?: 'AccessTokenObject', locale?: Types.Locales | null } | null, error?: { __typename?: 'AccessTokenObjecthe6oFwHOErrorObject', code?: string | null } | null } };

export type TestModeAutomateOnboardingToStripeMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type TestModeAutomateOnboardingToStripeMutation = { __typename?: 'Mutation', testModeAutomateOnboardingToStripe: { __typename?: 'BooleanResponseObject', object?: boolean | null, error?: { __typename?: 'BooleanResponseObjectErrorObject', code?: string | null } | null } };

export type SignOutMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SignOutMutation = { __typename?: 'Mutation', signOut: { __typename?: 'BooleanxIH9VuA8', object?: boolean | null, error?: { __typename?: 'BooleanxIH9VuA8ErrorObject', code?: string | null } | null } };

export type ResetPasswordMutationVariables = Types.Exact<{
  resetPasswordInput: Types.ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'AccessTokenObjectocwlpA1a', object?: { __typename?: 'AccessTokenObject', role?: Types.UserRoles | null } | null, error?: { __typename?: 'AccessTokenObjectocwlpA1aErrorObject', code?: Types.AccessTokenError | null } | null } };

export type CheckIfResetPasswordIsValidQueryVariables = Types.Exact<{
  checkIfResetPasswordIsValidInput: Types.CheckIfResetPasswordIsValidInput;
}>;


export type CheckIfResetPasswordIsValidQuery = { __typename?: 'Query', checkIfResetPasswordIsValid: { __typename?: 'BooleanV9rt7kFD', object?: boolean | null } };

export type SendResetPasswordRequestMutationVariables = Types.Exact<{
  sendResetPasswordRequestInput: Types.SendResetPasswordRequestInput;
}>;


export type SendResetPasswordRequestMutation = { __typename?: 'Mutation', sendResetPasswordRequest: { __typename?: 'ResetPasswordLinkResponseObject', object?: { __typename?: 'ResetPasswordLinkObject', user?: { __typename?: 'UserObject', id: string } | null } | null, error?: { __typename?: 'ResetPasswordLinkResponseObjectErrorObject', code?: Types.ResetPasswordLinkError | null } | null } };

export type EditPasswordMutationVariables = Types.Exact<{
  editPasswordInput: Types.EditPasswordInput;
}>;


export type EditPasswordMutation = { __typename?: 'Mutation', editPassword: { __typename?: 'UserObjecte05vAQuU', object?: { __typename?: 'UserObject', id: string } | null, error?: { __typename?: 'UserObjecte05vAQuUErrorObject', code?: string | null } | null } };

export type ActiveTwoFactorAuthMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type ActiveTwoFactorAuthMutation = { __typename?: 'Mutation', activeTwoFactorAuth: { __typename?: 'Boolean3e4Oz7vX', object?: boolean | null, error?: { __typename?: 'Boolean3e4Oz7vXErrorObject', code?: string | null } | null } };

export type DeactiveTwoFactorAuthMutationVariables = Types.Exact<{
  param: Types.DeactiveTwoFactorAuthInput;
}>;


export type DeactiveTwoFactorAuthMutation = { __typename?: 'Mutation', deactiveTwoFactorAuth: { __typename?: 'Booleany9Rx3RNP', object?: boolean | null, error?: { __typename?: 'Booleany9Rx3RNPErrorObject', code?: string | null } | null } };

export type GenerateCheckinManagerUrlQueryVariables = Types.Exact<{
  ticketingId: Types.Scalars['String'];
  occurrenceId?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GenerateCheckinManagerUrlQuery = { __typename?: 'Query', generateCheckinManagerUrl: { __typename?: 'StringyxxADV9I', object?: string | null } };

export type UpdateAccessTokenWithTargetedOrganizationMutationVariables = Types.Exact<{
  targetOrganizationId?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type UpdateAccessTokenWithTargetedOrganizationMutation = { __typename?: 'Mutation', updateAccessTokenWithTargetedOrganization: { __typename?: 'BooleanD4ILETcJ', object?: boolean | null } };

export type SetUserCurrentOrganizationMutationVariables = Types.Exact<{
  organizationId: Types.Scalars['String'];
}>;


export type SetUserCurrentOrganizationMutation = { __typename?: 'Mutation', setUserCurrentOrganization: { __typename?: 'AccessTokenObjectq930WrCn', error?: { __typename?: 'AccessTokenObjectq930WrCnErrorObject', code?: Types.AccessTokenError | null } | null } };

export type GetStripeCustomAccountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetStripeCustomAccountQuery = { __typename?: 'Query', getStripeCustomAccount: { __typename?: 'StripeAccountResponseObject', object?: { __typename?: 'StripeAccountObject', id: string, country: string, email?: string | null, type?: string | null, payoutInterval: Types.PayoutInterval, isBankConnected: boolean, hasAtLeastOnePayout?: boolean | null, hasOnlyOnePayout?: boolean | null, isRejectedByZeffy?: boolean | null, isRejectedByStripe?: boolean | null, requirements?: { __typename?: 'StripeRequirements', currently_due?: Array<string> | null, current_deadline?: number | null, pending_verification?: Array<string> | null } | null, future_requirements?: { __typename?: 'StripeRequirements', currently_due?: Array<string> | null, current_deadline?: number | null } | null, capabilities: { __typename?: 'StripeCapabilities', transfers?: Types.StripeCapabilityStatus | null, card_issuing?: Types.StripeCapabilityStatus | null }, lastPayout?: { __typename?: 'PayoutObject', id: string, status: Types.StripePayoutStatus, failureMessage?: string | null, failureCode?: string | null, externalAccount: { __typename?: 'ExternalAccountObject', id: string } } | null, externalAccount?: { __typename?: 'ExternalAccountObject', id: string, accountName?: string | null, routingNumber?: string | null, last4?: string | null, currency?: Types.AvailablePaymentCurrency | null, status?: Types.BankAccountStatus | null, bankName?: string | null, country?: Types.CountryCode | null } | null } | null } };

export type MergeUsersMutationVariables = Types.Exact<{
  oldEmail: Types.Scalars['String'];
  newEmail: Types.Scalars['String'];
  encryptedToken: Types.Scalars['String'];
}>;


export type MergeUsersMutation = { __typename?: 'Mutation', mergeUsers: { __typename?: 'MergeUsersObject4Ky2TjRo', object?: { __typename?: 'MergeUsersObject', role?: Types.UserRoles | null } | null, error?: { __typename?: 'MergeUsersObject4Ky2TjRoErrorObject', code?: Types.MergeUsersError | null } | null } };

export type VerifyEmailMutationVariables = Types.Exact<{
  email: Types.Scalars['String'];
  verifyEmailToken: Types.Scalars['String'];
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail: { __typename?: 'VerifyEmailObject9OjQsVKa', object?: { __typename?: 'VerifyEmailObject', role?: Types.UserRoles | null } | null, error?: { __typename?: 'VerifyEmailObject9OjQsVKaErrorObject', code?: string | null } | null } };

export type EditContactEmailMutationVariables = Types.Exact<{
  userId: Types.Scalars['String'];
  email: Types.Scalars['String'];
}>;


export type EditContactEmailMutation = { __typename?: 'Mutation', editContactEmail: { __typename?: 'UserObjectqNKQFVe7', object?: { __typename?: 'UserObject', id: string } | null, error?: { __typename?: 'UserObjectqNKQFVe7ErrorObject', code?: string | null } | null } };


export const GetFrontendCurrentUserDocument = gql`
    query getFrontendCurrentUser {
  getFrontendCurrentUser {
    object {
      id
      deprecatedMongoId
      email
      firstName
      lastName
      locale
      fullName
      phone
      maskedPhoneNumber
      role
      hasAnyBankPermission
      emailVerified
      isTwoFactorActivated
      isAuthenticatedWithGoogleSSO
      isMigratedOnStytch
      isLoginSmsMfaActivated
      isBankChangeSmsMfaActivated
      createdAtUtc
      connectedAsAdministrator
      zeffyAdministrator
      hasSeenReferralPage
      isOnboardedOnCheckinManager
      hasDismissedEmailInfobox
      hasDismissedReferralPromptAtFirstPayout
      hasDismissedEmailTemplatePrompt
      stripeCustomers {
        id
        country
        stripeCustomerId
      }
      currentOrganization {
        name
        id
        address
        city
        postalCode
        country
        region
        phoneNumber
        charityNumber
        stripeCustomAccountId
        signatureUrl
        logoUrl
        dismissOnboardingOnFormPageAt
        previewFirstFormAt
        hasAdministrativeInformation
        hasCharityNumber
        canGenerateReceipt
        deprecatedMongoId
        volumeThresholdReached
        bankDescriptor
        referralQuestion
        referralQuestionOther
        cause
        website
        stripeUserId
        stripeCustomAccountId
        hasStripeCustomFlowStarted
        isStripeCustomAccountActive
        stripeCustomAccountActiveAtUtc
        type
        fraudulent
        color
        hideFromZeffyMap
        isPoBoxAddress
        hasAtLeastOnePayment
        badTipperHubspotFlag
        category
        firstPaymentDate
        lastPaymentDate
        fourthPaymentDate
        onboardedFormCategory
        propublicaCCode
        hasFinishZeffyOnboarding
        createdAtUtc
        balanceTransferDelayDay
        stripeTopupSourceId
        activationChecklistExperiment
        engagementChecklistExperiment
        referralAmountLimit
        hasDismissActivationPayoutSuccessCard
        engagementCheckListStepChecked
        hasVisitorReports
        demotivateEmbeds
        hasImportGmailContacts
        hasImportMailchimpContacts
        hubspotNpoStarterDealId
        npoStarterStateCertificateUrl
        npoStarterToDoListStepChecked
        stripeVerificationSucceededBannerShown
        featureTreasuryEnabled
        featureIssuingEnabled
        hasClosedFinancialAccountReadyBanner
      }
      currentOrganizationDetails {
        closingDate
        fundsRaised
        numberContacts
        numberPayments
        numberForms
        numberUserAccounts
        numberOfReferrals
      }
      organizationGroups {
        organizationId
        role
        permissions
        organization {
          name
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetFrontendCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetFrontendCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFrontendCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrontendCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFrontendCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetFrontendCurrentUserQuery, GetFrontendCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFrontendCurrentUserQuery, GetFrontendCurrentUserQueryVariables>(GetFrontendCurrentUserDocument, options);
      }
export function useGetFrontendCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFrontendCurrentUserQuery, GetFrontendCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFrontendCurrentUserQuery, GetFrontendCurrentUserQueryVariables>(GetFrontendCurrentUserDocument, options);
        }
export type GetFrontendCurrentUserQueryHookResult = ReturnType<typeof useGetFrontendCurrentUserQuery>;
export type GetFrontendCurrentUserLazyQueryHookResult = ReturnType<typeof useGetFrontendCurrentUserLazyQuery>;
export type GetFrontendCurrentUserQueryResult = Apollo.QueryResult<GetFrontendCurrentUserQuery, GetFrontendCurrentUserQueryVariables>;
export const IsUserEmailRegisteredDocument = gql`
    mutation isUserEmailRegistered($isEmailRegisteredInput: IsEmailRegisteredInput!) {
  isUserEmailRegistered(isEmailRegisteredInput: $isEmailRegisteredInput) {
    object {
      userId
      userRegistrationStatus
      hasPassword
      hasResetPasswordToken
      hadPasswordInSimplykV1
      fundraiserCreationToken
      shouldAuthenticateWithGoogle
    }
    error {
      code
      message
    }
  }
}
    `;
export type IsUserEmailRegisteredMutationFn = Apollo.MutationFunction<IsUserEmailRegisteredMutation, IsUserEmailRegisteredMutationVariables>;

/**
 * __useIsUserEmailRegisteredMutation__
 *
 * To run a mutation, you first call `useIsUserEmailRegisteredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIsUserEmailRegisteredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [isUserEmailRegisteredMutation, { data, loading, error }] = useIsUserEmailRegisteredMutation({
 *   variables: {
 *      isEmailRegisteredInput: // value for 'isEmailRegisteredInput'
 *   },
 * });
 */
export function useIsUserEmailRegisteredMutation(baseOptions?: Apollo.MutationHookOptions<IsUserEmailRegisteredMutation, IsUserEmailRegisteredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IsUserEmailRegisteredMutation, IsUserEmailRegisteredMutationVariables>(IsUserEmailRegisteredDocument, options);
      }
export type IsUserEmailRegisteredMutationHookResult = ReturnType<typeof useIsUserEmailRegisteredMutation>;
export type IsUserEmailRegisteredMutationResult = Apollo.MutationResult<IsUserEmailRegisteredMutation>;
export type IsUserEmailRegisteredMutationOptions = Apollo.BaseMutationOptions<IsUserEmailRegisteredMutation, IsUserEmailRegisteredMutationVariables>;
export const SignInDocument = gql`
    mutation signIn($signInInput: SignInFrontendInput!) {
  signIn(signInInput: $signInInput) {
    object {
      email
      shouldAuthenticateWithTwoFactor
      shouldAuthenticateBySms
      stytchVerdict
      maskedPhoneNumber
      role
      locale
      redirectUrl
      shouldRedirectToMFAConfig
    }
    error {
      code
    }
  }
}
    `;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      signInInput: // value for 'signInInput'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const ResendTwoFactorCodeDocument = gql`
    mutation resendTwoFactorCode($signInInput: SignInFrontendInput!) {
  resendTwoFactorCode(signInInput: $signInInput) {
    object
  }
}
    `;
export type ResendTwoFactorCodeMutationFn = Apollo.MutationFunction<ResendTwoFactorCodeMutation, ResendTwoFactorCodeMutationVariables>;

/**
 * __useResendTwoFactorCodeMutation__
 *
 * To run a mutation, you first call `useResendTwoFactorCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendTwoFactorCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendTwoFactorCodeMutation, { data, loading, error }] = useResendTwoFactorCodeMutation({
 *   variables: {
 *      signInInput: // value for 'signInInput'
 *   },
 * });
 */
export function useResendTwoFactorCodeMutation(baseOptions?: Apollo.MutationHookOptions<ResendTwoFactorCodeMutation, ResendTwoFactorCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendTwoFactorCodeMutation, ResendTwoFactorCodeMutationVariables>(ResendTwoFactorCodeDocument, options);
      }
export type ResendTwoFactorCodeMutationHookResult = ReturnType<typeof useResendTwoFactorCodeMutation>;
export type ResendTwoFactorCodeMutationResult = Apollo.MutationResult<ResendTwoFactorCodeMutation>;
export type ResendTwoFactorCodeMutationOptions = Apollo.BaseMutationOptions<ResendTwoFactorCodeMutation, ResendTwoFactorCodeMutationVariables>;
export const SendTwoFactorCodeDocument = gql`
    mutation sendTwoFactorCode {
  sendTwoFactorCode {
    object
  }
}
    `;
export type SendTwoFactorCodeMutationFn = Apollo.MutationFunction<SendTwoFactorCodeMutation, SendTwoFactorCodeMutationVariables>;

/**
 * __useSendTwoFactorCodeMutation__
 *
 * To run a mutation, you first call `useSendTwoFactorCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTwoFactorCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTwoFactorCodeMutation, { data, loading, error }] = useSendTwoFactorCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendTwoFactorCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendTwoFactorCodeMutation, SendTwoFactorCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTwoFactorCodeMutation, SendTwoFactorCodeMutationVariables>(SendTwoFactorCodeDocument, options);
      }
export type SendTwoFactorCodeMutationHookResult = ReturnType<typeof useSendTwoFactorCodeMutation>;
export type SendTwoFactorCodeMutationResult = Apollo.MutationResult<SendTwoFactorCodeMutation>;
export type SendTwoFactorCodeMutationOptions = Apollo.BaseMutationOptions<SendTwoFactorCodeMutation, SendTwoFactorCodeMutationVariables>;
export const VerifyTwoFactorCodeDocument = gql`
    mutation verifyTwoFactorCode($value: String!) {
  verifyTwoFactorCode(value: $value) {
    object
    error {
      code
      message
    }
  }
}
    `;
export type VerifyTwoFactorCodeMutationFn = Apollo.MutationFunction<VerifyTwoFactorCodeMutation, VerifyTwoFactorCodeMutationVariables>;

/**
 * __useVerifyTwoFactorCodeMutation__
 *
 * To run a mutation, you first call `useVerifyTwoFactorCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTwoFactorCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTwoFactorCodeMutation, { data, loading, error }] = useVerifyTwoFactorCodeMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useVerifyTwoFactorCodeMutation(baseOptions?: Apollo.MutationHookOptions<VerifyTwoFactorCodeMutation, VerifyTwoFactorCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyTwoFactorCodeMutation, VerifyTwoFactorCodeMutationVariables>(VerifyTwoFactorCodeDocument, options);
      }
export type VerifyTwoFactorCodeMutationHookResult = ReturnType<typeof useVerifyTwoFactorCodeMutation>;
export type VerifyTwoFactorCodeMutationResult = Apollo.MutationResult<VerifyTwoFactorCodeMutation>;
export type VerifyTwoFactorCodeMutationOptions = Apollo.BaseMutationOptions<VerifyTwoFactorCodeMutation, VerifyTwoFactorCodeMutationVariables>;
export const SignInAsAdministratorDocument = gql`
    mutation signInAsAdministrator($signInAsAdministratorInput: SignInAsAdministratorInput!) {
  signInAsAdministrator(signInAsAdministratorInput: $signInAsAdministratorInput) {
    object {
      role
      locale
    }
    error {
      code
    }
  }
}
    `;
export type SignInAsAdministratorMutationFn = Apollo.MutationFunction<SignInAsAdministratorMutation, SignInAsAdministratorMutationVariables>;

/**
 * __useSignInAsAdministratorMutation__
 *
 * To run a mutation, you first call `useSignInAsAdministratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInAsAdministratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInAsAdministratorMutation, { data, loading, error }] = useSignInAsAdministratorMutation({
 *   variables: {
 *      signInAsAdministratorInput: // value for 'signInAsAdministratorInput'
 *   },
 * });
 */
export function useSignInAsAdministratorMutation(baseOptions?: Apollo.MutationHookOptions<SignInAsAdministratorMutation, SignInAsAdministratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInAsAdministratorMutation, SignInAsAdministratorMutationVariables>(SignInAsAdministratorDocument, options);
      }
export type SignInAsAdministratorMutationHookResult = ReturnType<typeof useSignInAsAdministratorMutation>;
export type SignInAsAdministratorMutationResult = Apollo.MutationResult<SignInAsAdministratorMutation>;
export type SignInAsAdministratorMutationOptions = Apollo.BaseMutationOptions<SignInAsAdministratorMutation, SignInAsAdministratorMutationVariables>;
export const SwitchOrgAsAdministratorDocument = gql`
    mutation switchOrgAsAdministrator($switchOrgAsAdministratorInput: SwitchOrgAsAdministratorInput!) {
  switchOrgAsAdministrator(
    switchOrgAsAdministratorInput: $switchOrgAsAdministratorInput
  ) {
    object {
      role
      locale
    }
    error {
      code
    }
  }
}
    `;
export type SwitchOrgAsAdministratorMutationFn = Apollo.MutationFunction<SwitchOrgAsAdministratorMutation, SwitchOrgAsAdministratorMutationVariables>;

/**
 * __useSwitchOrgAsAdministratorMutation__
 *
 * To run a mutation, you first call `useSwitchOrgAsAdministratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchOrgAsAdministratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchOrgAsAdministratorMutation, { data, loading, error }] = useSwitchOrgAsAdministratorMutation({
 *   variables: {
 *      switchOrgAsAdministratorInput: // value for 'switchOrgAsAdministratorInput'
 *   },
 * });
 */
export function useSwitchOrgAsAdministratorMutation(baseOptions?: Apollo.MutationHookOptions<SwitchOrgAsAdministratorMutation, SwitchOrgAsAdministratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchOrgAsAdministratorMutation, SwitchOrgAsAdministratorMutationVariables>(SwitchOrgAsAdministratorDocument, options);
      }
export type SwitchOrgAsAdministratorMutationHookResult = ReturnType<typeof useSwitchOrgAsAdministratorMutation>;
export type SwitchOrgAsAdministratorMutationResult = Apollo.MutationResult<SwitchOrgAsAdministratorMutation>;
export type SwitchOrgAsAdministratorMutationOptions = Apollo.BaseMutationOptions<SwitchOrgAsAdministratorMutation, SwitchOrgAsAdministratorMutationVariables>;
export const SignUpDocument = gql`
    mutation signUp($signUpInput: SignUpInput!) {
  signUp(signUpInput: $signUpInput) {
    object {
      locale
    }
    error {
      code
    }
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      signUpInput: // value for 'signUpInput'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const TestModeAutomateOnboardingToStripeDocument = gql`
    mutation testModeAutomateOnboardingToStripe {
  testModeAutomateOnboardingToStripe {
    object
    error {
      code
    }
  }
}
    `;
export type TestModeAutomateOnboardingToStripeMutationFn = Apollo.MutationFunction<TestModeAutomateOnboardingToStripeMutation, TestModeAutomateOnboardingToStripeMutationVariables>;

/**
 * __useTestModeAutomateOnboardingToStripeMutation__
 *
 * To run a mutation, you first call `useTestModeAutomateOnboardingToStripeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestModeAutomateOnboardingToStripeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testModeAutomateOnboardingToStripeMutation, { data, loading, error }] = useTestModeAutomateOnboardingToStripeMutation({
 *   variables: {
 *   },
 * });
 */
export function useTestModeAutomateOnboardingToStripeMutation(baseOptions?: Apollo.MutationHookOptions<TestModeAutomateOnboardingToStripeMutation, TestModeAutomateOnboardingToStripeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestModeAutomateOnboardingToStripeMutation, TestModeAutomateOnboardingToStripeMutationVariables>(TestModeAutomateOnboardingToStripeDocument, options);
      }
export type TestModeAutomateOnboardingToStripeMutationHookResult = ReturnType<typeof useTestModeAutomateOnboardingToStripeMutation>;
export type TestModeAutomateOnboardingToStripeMutationResult = Apollo.MutationResult<TestModeAutomateOnboardingToStripeMutation>;
export type TestModeAutomateOnboardingToStripeMutationOptions = Apollo.BaseMutationOptions<TestModeAutomateOnboardingToStripeMutation, TestModeAutomateOnboardingToStripeMutationVariables>;
export const SignOutDocument = gql`
    mutation signOut {
  signOut {
    object
    error {
      code
    }
  }
}
    `;
export type SignOutMutationFn = Apollo.MutationFunction<SignOutMutation, SignOutMutationVariables>;

/**
 * __useSignOutMutation__
 *
 * To run a mutation, you first call `useSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutMutation, { data, loading, error }] = useSignOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutMutation(baseOptions?: Apollo.MutationHookOptions<SignOutMutation, SignOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignOutMutation, SignOutMutationVariables>(SignOutDocument, options);
      }
export type SignOutMutationHookResult = ReturnType<typeof useSignOutMutation>;
export type SignOutMutationResult = Apollo.MutationResult<SignOutMutation>;
export type SignOutMutationOptions = Apollo.BaseMutationOptions<SignOutMutation, SignOutMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($resetPasswordInput: ResetPasswordInput!) {
  resetPassword(resetPasswordInput: $resetPasswordInput) {
    object {
      role
    }
    error {
      code
    }
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      resetPasswordInput: // value for 'resetPasswordInput'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const CheckIfResetPasswordIsValidDocument = gql`
    query checkIfResetPasswordIsValid($checkIfResetPasswordIsValidInput: CheckIfResetPasswordIsValidInput!) {
  checkIfResetPasswordIsValid(
    checkIfResetPasswordIsValidInput: $checkIfResetPasswordIsValidInput
  ) {
    object
  }
}
    `;

/**
 * __useCheckIfResetPasswordIsValidQuery__
 *
 * To run a query within a React component, call `useCheckIfResetPasswordIsValidQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfResetPasswordIsValidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfResetPasswordIsValidQuery({
 *   variables: {
 *      checkIfResetPasswordIsValidInput: // value for 'checkIfResetPasswordIsValidInput'
 *   },
 * });
 */
export function useCheckIfResetPasswordIsValidQuery(baseOptions: Apollo.QueryHookOptions<CheckIfResetPasswordIsValidQuery, CheckIfResetPasswordIsValidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIfResetPasswordIsValidQuery, CheckIfResetPasswordIsValidQueryVariables>(CheckIfResetPasswordIsValidDocument, options);
      }
export function useCheckIfResetPasswordIsValidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIfResetPasswordIsValidQuery, CheckIfResetPasswordIsValidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIfResetPasswordIsValidQuery, CheckIfResetPasswordIsValidQueryVariables>(CheckIfResetPasswordIsValidDocument, options);
        }
export type CheckIfResetPasswordIsValidQueryHookResult = ReturnType<typeof useCheckIfResetPasswordIsValidQuery>;
export type CheckIfResetPasswordIsValidLazyQueryHookResult = ReturnType<typeof useCheckIfResetPasswordIsValidLazyQuery>;
export type CheckIfResetPasswordIsValidQueryResult = Apollo.QueryResult<CheckIfResetPasswordIsValidQuery, CheckIfResetPasswordIsValidQueryVariables>;
export const SendResetPasswordRequestDocument = gql`
    mutation sendResetPasswordRequest($sendResetPasswordRequestInput: SendResetPasswordRequestInput!) {
  sendResetPasswordRequest(
    sendResetPasswordRequestInput: $sendResetPasswordRequestInput
  ) {
    object {
      user {
        id
      }
    }
    error {
      code
    }
  }
}
    `;
export type SendResetPasswordRequestMutationFn = Apollo.MutationFunction<SendResetPasswordRequestMutation, SendResetPasswordRequestMutationVariables>;

/**
 * __useSendResetPasswordRequestMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordRequestMutation, { data, loading, error }] = useSendResetPasswordRequestMutation({
 *   variables: {
 *      sendResetPasswordRequestInput: // value for 'sendResetPasswordRequestInput'
 *   },
 * });
 */
export function useSendResetPasswordRequestMutation(baseOptions?: Apollo.MutationHookOptions<SendResetPasswordRequestMutation, SendResetPasswordRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendResetPasswordRequestMutation, SendResetPasswordRequestMutationVariables>(SendResetPasswordRequestDocument, options);
      }
export type SendResetPasswordRequestMutationHookResult = ReturnType<typeof useSendResetPasswordRequestMutation>;
export type SendResetPasswordRequestMutationResult = Apollo.MutationResult<SendResetPasswordRequestMutation>;
export type SendResetPasswordRequestMutationOptions = Apollo.BaseMutationOptions<SendResetPasswordRequestMutation, SendResetPasswordRequestMutationVariables>;
export const EditPasswordDocument = gql`
    mutation editPassword($editPasswordInput: EditPasswordInput!) {
  editPassword(editPasswordInput: $editPasswordInput) {
    object {
      id
    }
    error {
      code
    }
  }
}
    `;
export type EditPasswordMutationFn = Apollo.MutationFunction<EditPasswordMutation, EditPasswordMutationVariables>;

/**
 * __useEditPasswordMutation__
 *
 * To run a mutation, you first call `useEditPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPasswordMutation, { data, loading, error }] = useEditPasswordMutation({
 *   variables: {
 *      editPasswordInput: // value for 'editPasswordInput'
 *   },
 * });
 */
export function useEditPasswordMutation(baseOptions?: Apollo.MutationHookOptions<EditPasswordMutation, EditPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPasswordMutation, EditPasswordMutationVariables>(EditPasswordDocument, options);
      }
export type EditPasswordMutationHookResult = ReturnType<typeof useEditPasswordMutation>;
export type EditPasswordMutationResult = Apollo.MutationResult<EditPasswordMutation>;
export type EditPasswordMutationOptions = Apollo.BaseMutationOptions<EditPasswordMutation, EditPasswordMutationVariables>;
export const ActiveTwoFactorAuthDocument = gql`
    mutation activeTwoFactorAuth {
  activeTwoFactorAuth {
    object
    error {
      code
    }
  }
}
    `;
export type ActiveTwoFactorAuthMutationFn = Apollo.MutationFunction<ActiveTwoFactorAuthMutation, ActiveTwoFactorAuthMutationVariables>;

/**
 * __useActiveTwoFactorAuthMutation__
 *
 * To run a mutation, you first call `useActiveTwoFactorAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActiveTwoFactorAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activeTwoFactorAuthMutation, { data, loading, error }] = useActiveTwoFactorAuthMutation({
 *   variables: {
 *   },
 * });
 */
export function useActiveTwoFactorAuthMutation(baseOptions?: Apollo.MutationHookOptions<ActiveTwoFactorAuthMutation, ActiveTwoFactorAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActiveTwoFactorAuthMutation, ActiveTwoFactorAuthMutationVariables>(ActiveTwoFactorAuthDocument, options);
      }
export type ActiveTwoFactorAuthMutationHookResult = ReturnType<typeof useActiveTwoFactorAuthMutation>;
export type ActiveTwoFactorAuthMutationResult = Apollo.MutationResult<ActiveTwoFactorAuthMutation>;
export type ActiveTwoFactorAuthMutationOptions = Apollo.BaseMutationOptions<ActiveTwoFactorAuthMutation, ActiveTwoFactorAuthMutationVariables>;
export const DeactiveTwoFactorAuthDocument = gql`
    mutation deactiveTwoFactorAuth($param: DeactiveTwoFactorAuthInput!) {
  deactiveTwoFactorAuth(param: $param) {
    object
    error {
      code
    }
  }
}
    `;
export type DeactiveTwoFactorAuthMutationFn = Apollo.MutationFunction<DeactiveTwoFactorAuthMutation, DeactiveTwoFactorAuthMutationVariables>;

/**
 * __useDeactiveTwoFactorAuthMutation__
 *
 * To run a mutation, you first call `useDeactiveTwoFactorAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactiveTwoFactorAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactiveTwoFactorAuthMutation, { data, loading, error }] = useDeactiveTwoFactorAuthMutation({
 *   variables: {
 *      param: // value for 'param'
 *   },
 * });
 */
export function useDeactiveTwoFactorAuthMutation(baseOptions?: Apollo.MutationHookOptions<DeactiveTwoFactorAuthMutation, DeactiveTwoFactorAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactiveTwoFactorAuthMutation, DeactiveTwoFactorAuthMutationVariables>(DeactiveTwoFactorAuthDocument, options);
      }
export type DeactiveTwoFactorAuthMutationHookResult = ReturnType<typeof useDeactiveTwoFactorAuthMutation>;
export type DeactiveTwoFactorAuthMutationResult = Apollo.MutationResult<DeactiveTwoFactorAuthMutation>;
export type DeactiveTwoFactorAuthMutationOptions = Apollo.BaseMutationOptions<DeactiveTwoFactorAuthMutation, DeactiveTwoFactorAuthMutationVariables>;
export const GenerateCheckinManagerUrlDocument = gql`
    query generateCheckinManagerUrl($ticketingId: String!, $occurrenceId: String) {
  generateCheckinManagerUrl(
    ticketingId: $ticketingId
    occurrenceId: $occurrenceId
  ) {
    object
  }
}
    `;

/**
 * __useGenerateCheckinManagerUrlQuery__
 *
 * To run a query within a React component, call `useGenerateCheckinManagerUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateCheckinManagerUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateCheckinManagerUrlQuery({
 *   variables: {
 *      ticketingId: // value for 'ticketingId'
 *      occurrenceId: // value for 'occurrenceId'
 *   },
 * });
 */
export function useGenerateCheckinManagerUrlQuery(baseOptions: Apollo.QueryHookOptions<GenerateCheckinManagerUrlQuery, GenerateCheckinManagerUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateCheckinManagerUrlQuery, GenerateCheckinManagerUrlQueryVariables>(GenerateCheckinManagerUrlDocument, options);
      }
export function useGenerateCheckinManagerUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateCheckinManagerUrlQuery, GenerateCheckinManagerUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateCheckinManagerUrlQuery, GenerateCheckinManagerUrlQueryVariables>(GenerateCheckinManagerUrlDocument, options);
        }
export type GenerateCheckinManagerUrlQueryHookResult = ReturnType<typeof useGenerateCheckinManagerUrlQuery>;
export type GenerateCheckinManagerUrlLazyQueryHookResult = ReturnType<typeof useGenerateCheckinManagerUrlLazyQuery>;
export type GenerateCheckinManagerUrlQueryResult = Apollo.QueryResult<GenerateCheckinManagerUrlQuery, GenerateCheckinManagerUrlQueryVariables>;
export const UpdateAccessTokenWithTargetedOrganizationDocument = gql`
    mutation updateAccessTokenWithTargetedOrganization($targetOrganizationId: String) {
  updateAccessTokenWithTargetedOrganization(
    targetOrganizationId: $targetOrganizationId
  ) {
    object
  }
}
    `;
export type UpdateAccessTokenWithTargetedOrganizationMutationFn = Apollo.MutationFunction<UpdateAccessTokenWithTargetedOrganizationMutation, UpdateAccessTokenWithTargetedOrganizationMutationVariables>;

/**
 * __useUpdateAccessTokenWithTargetedOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateAccessTokenWithTargetedOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccessTokenWithTargetedOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccessTokenWithTargetedOrganizationMutation, { data, loading, error }] = useUpdateAccessTokenWithTargetedOrganizationMutation({
 *   variables: {
 *      targetOrganizationId: // value for 'targetOrganizationId'
 *   },
 * });
 */
export function useUpdateAccessTokenWithTargetedOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccessTokenWithTargetedOrganizationMutation, UpdateAccessTokenWithTargetedOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccessTokenWithTargetedOrganizationMutation, UpdateAccessTokenWithTargetedOrganizationMutationVariables>(UpdateAccessTokenWithTargetedOrganizationDocument, options);
      }
export type UpdateAccessTokenWithTargetedOrganizationMutationHookResult = ReturnType<typeof useUpdateAccessTokenWithTargetedOrganizationMutation>;
export type UpdateAccessTokenWithTargetedOrganizationMutationResult = Apollo.MutationResult<UpdateAccessTokenWithTargetedOrganizationMutation>;
export type UpdateAccessTokenWithTargetedOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateAccessTokenWithTargetedOrganizationMutation, UpdateAccessTokenWithTargetedOrganizationMutationVariables>;
export const SetUserCurrentOrganizationDocument = gql`
    mutation setUserCurrentOrganization($organizationId: String!) {
  setUserCurrentOrganization(organizationId: $organizationId) {
    error {
      code
    }
  }
}
    `;
export type SetUserCurrentOrganizationMutationFn = Apollo.MutationFunction<SetUserCurrentOrganizationMutation, SetUserCurrentOrganizationMutationVariables>;

/**
 * __useSetUserCurrentOrganizationMutation__
 *
 * To run a mutation, you first call `useSetUserCurrentOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserCurrentOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserCurrentOrganizationMutation, { data, loading, error }] = useSetUserCurrentOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSetUserCurrentOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SetUserCurrentOrganizationMutation, SetUserCurrentOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserCurrentOrganizationMutation, SetUserCurrentOrganizationMutationVariables>(SetUserCurrentOrganizationDocument, options);
      }
export type SetUserCurrentOrganizationMutationHookResult = ReturnType<typeof useSetUserCurrentOrganizationMutation>;
export type SetUserCurrentOrganizationMutationResult = Apollo.MutationResult<SetUserCurrentOrganizationMutation>;
export type SetUserCurrentOrganizationMutationOptions = Apollo.BaseMutationOptions<SetUserCurrentOrganizationMutation, SetUserCurrentOrganizationMutationVariables>;
export const GetStripeCustomAccountDocument = gql`
    query getStripeCustomAccount {
  getStripeCustomAccount {
    object {
      id
      country
      email
      type
      payoutInterval
      isBankConnected
      hasAtLeastOnePayout
      hasOnlyOnePayout
      isRejectedByZeffy
      isRejectedByStripe
      requirements {
        currently_due
        current_deadline
        pending_verification
      }
      future_requirements {
        currently_due
        current_deadline
      }
      capabilities {
        transfers
        card_issuing
      }
      lastPayout {
        id
        status
        failureMessage
        failureCode
        externalAccount {
          id
        }
      }
      externalAccount {
        id
        accountName
        routingNumber
        last4
        currency
        status
        bankName
        country
      }
    }
  }
}
    `;

/**
 * __useGetStripeCustomAccountQuery__
 *
 * To run a query within a React component, call `useGetStripeCustomAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeCustomAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeCustomAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStripeCustomAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetStripeCustomAccountQuery, GetStripeCustomAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeCustomAccountQuery, GetStripeCustomAccountQueryVariables>(GetStripeCustomAccountDocument, options);
      }
export function useGetStripeCustomAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeCustomAccountQuery, GetStripeCustomAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeCustomAccountQuery, GetStripeCustomAccountQueryVariables>(GetStripeCustomAccountDocument, options);
        }
export type GetStripeCustomAccountQueryHookResult = ReturnType<typeof useGetStripeCustomAccountQuery>;
export type GetStripeCustomAccountLazyQueryHookResult = ReturnType<typeof useGetStripeCustomAccountLazyQuery>;
export type GetStripeCustomAccountQueryResult = Apollo.QueryResult<GetStripeCustomAccountQuery, GetStripeCustomAccountQueryVariables>;
export const MergeUsersDocument = gql`
    mutation mergeUsers($oldEmail: String!, $newEmail: String!, $encryptedToken: String!) {
  mergeUsers(
    oldEmail: $oldEmail
    newEmail: $newEmail
    encryptedToken: $encryptedToken
  ) {
    object {
      role
    }
    error {
      code
    }
  }
}
    `;
export type MergeUsersMutationFn = Apollo.MutationFunction<MergeUsersMutation, MergeUsersMutationVariables>;

/**
 * __useMergeUsersMutation__
 *
 * To run a mutation, you first call `useMergeUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeUsersMutation, { data, loading, error }] = useMergeUsersMutation({
 *   variables: {
 *      oldEmail: // value for 'oldEmail'
 *      newEmail: // value for 'newEmail'
 *      encryptedToken: // value for 'encryptedToken'
 *   },
 * });
 */
export function useMergeUsersMutation(baseOptions?: Apollo.MutationHookOptions<MergeUsersMutation, MergeUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeUsersMutation, MergeUsersMutationVariables>(MergeUsersDocument, options);
      }
export type MergeUsersMutationHookResult = ReturnType<typeof useMergeUsersMutation>;
export type MergeUsersMutationResult = Apollo.MutationResult<MergeUsersMutation>;
export type MergeUsersMutationOptions = Apollo.BaseMutationOptions<MergeUsersMutation, MergeUsersMutationVariables>;
export const VerifyEmailDocument = gql`
    mutation verifyEmail($email: String!, $verifyEmailToken: String!) {
  verifyEmail(email: $email, verifyEmailToken: $verifyEmailToken) {
    object {
      role
    }
    error {
      code
    }
  }
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      verifyEmailToken: // value for 'verifyEmailToken'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const EditContactEmailDocument = gql`
    mutation editContactEmail($userId: String!, $email: String!) {
  editContactEmail(userId: $userId, email: $email) {
    object {
      id
    }
    error {
      code
    }
  }
}
    `;
export type EditContactEmailMutationFn = Apollo.MutationFunction<EditContactEmailMutation, EditContactEmailMutationVariables>;

/**
 * __useEditContactEmailMutation__
 *
 * To run a mutation, you first call `useEditContactEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContactEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContactEmailMutation, { data, loading, error }] = useEditContactEmailMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useEditContactEmailMutation(baseOptions?: Apollo.MutationHookOptions<EditContactEmailMutation, EditContactEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditContactEmailMutation, EditContactEmailMutationVariables>(EditContactEmailDocument, options);
      }
export type EditContactEmailMutationHookResult = ReturnType<typeof useEditContactEmailMutation>;
export type EditContactEmailMutationResult = Apollo.MutationResult<EditContactEmailMutation>;
export type EditContactEmailMutationOptions = Apollo.BaseMutationOptions<EditContactEmailMutation, EditContactEmailMutationVariables>;